export const resolveCanonicalEntryText = (row = {}) => String(
  row?.body
  || row?.note
  || row?.text
  || row?.content
  || row?.details
  || row?.description
  || row?.summary
  || row?.value
  || ''
).trim();

export const resolveCanonicalSourceText = (row = {}, rawText = '', fallbackText = '') => String(
  row?.sourceText
  || row?.originalText
  || rawText
  || fallbackText
  || ''
).trim();

export const resolveCanonicalOriginalText = (row = {}, rawText = '', fallbackText = '') => String(
  row?.originalText
  || row?.sourceText
  || rawText
  || fallbackText
  || ''
).trim();

export const isGenericSemanticTitle = (title = '', category = '') => {
  const normalizedTitle = String(title || '').trim().toLowerCase();
  const normalizedCategory = String(category || '').trim().toLowerCase();

  return !normalizedTitle
    || normalizedTitle === normalizedCategory
    || normalizedTitle === 'behavior'
    || normalizedTitle === 'medication'
    || normalizedTitle === 'meds'
    || normalizedTitle === 'food'
    || normalizedTitle === 'sleep'
    || normalizedTitle === 'activity'
    || normalizedTitle === 'mood'
    || normalizedTitle === 'toilet'
    || normalizedTitle === 'bathroom'
    || normalizedTitle === 'log'
    || normalizedTitle === 'medication log'
    || normalizedTitle === 'behavior log'
    || normalizedTitle === 'activity log'
    || normalizedTitle === 'mood log';
};
